import { render, staticRenderFns } from "./culturalHeritageList.vue?vue&type=template&id=4944d0f5&scoped=true"
import script from "./culturalHeritageList.vue?vue&type=script&lang=js"
export * from "./culturalHeritageList.vue?vue&type=script&lang=js"
import style0 from "./culturalHeritageList.vue?vue&type=style&index=0&id=4944d0f5&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4944d0f5",
  null
  
)

export default component.exports